import { render } from "./jianhuyi.vue?vue&type=template&id=3ab0bc8c"
import script from "./jianhuyi.vue?vue&type=script&lang=js"
export * from "./jianhuyi.vue?vue&type=script&lang=js"

import "./jianhuyi.vue?vue&type=style&index=0&id=3ab0bc8c&lang=scss"

import exportComponent from "/home/jenkins/workspace/xujiaxin-linchuang-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__